import React from 'react';
import { Building2, House } from 'lucide-react';
import { useAppStore } from '../store';
import { T } from '../i18n';

const OBJECTS = [
  { id: 'store', icon: House, labelKey: 'store' },
  { id: 'pergola', icon: Building2, labelKey: 'pergola' }
];

export default function ObjectBar({ onSelect }) {
  const { lang, currentObject } = useAppStore();
  const t = T[lang] || T.fr;
  
  return (
    <div className="bg-secondary flex items-center px-2 py-2 overflow-x-auto gap-2 flex-shrink-0"
      style={{ scrollbarWidth: 'none' }}
    >
      {OBJECTS.map((obj) => {
        const Icon = obj.icon;
        return (
          <button
            key={obj.id}
            onClick={() => onSelect(obj.id)}
            className={`flex flex-col items-center gap-1 px-4 py-2 rounded-xl border-2 transition-all flex-shrink-0 touch-feedback ${
              currentObject === obj.id
                ? 'bg-black/20 border-primary'
                : 'border-transparent hover:bg-black/10'
            }`}
            data-testid={`obj-${obj.id}`}
          >
            <Icon size={22} className="text-white" />
            <span className="text-[10px] font-bold text-white tracking-wider uppercase">
              {t[obj.labelKey]}
            </span>
          </button>
        );
      })}
    </div>
  );
}
